module.exports = __webpack_public_path__ + "img/gold.de860a8b.png";